<template>
  <div class="row">
    <div class="col-md-9">
      <p style="display:flex; align-items:center;">
        <ChooseCityComponent
          style="width: 150px;float:left"
        ></ChooseCityComponent>
        &nbsp;地区的话题:
      </p>
      <UserPublicPage :id="id"></UserPublicPage>
    </div>
    <div class="col-md-3">
      <UserSidebar v-if="id" :key="userKey" :id="id"> </UserSidebar>
    </div>
  </div>
</template>

<script>
import UserPublicPage from "../components/UserPublicPage.vue";
import UserSidebar from "../components/UserSidebarComponent.vue";
import ChooseCityComponent from "../components/ChooseCityComponent.vue";

export default {
  data() {
    return {
      userKey: Math.random()
    };
  },
  props: ["id"],
  components: {
    UserPublicPage,
    UserSidebar,
    ChooseCityComponent
  }
};
</script>
